module.exports = {
      id: "8795121644fb57d09edaba232ece92beroofShape-pyramid.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#8795121644fb57d09edaba232ece92beroofShape-pyramid.svg",
      toString: function () {
        return this.url;
      }
    }